import React from "react";
import AssessmentsManager from "./AssessmentsManager";
import { TFunction } from "i18next";

interface IProps {
    t: TFunction;
}

const JobAssessments = (props: IProps) => {
    return <AssessmentsManager />;
};

export default JobAssessments;
